<template>
<div id="newsletter-send-to-emails">
  <div class="modal" id="send-to-emails-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Send This {{ title }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
          <div class="modal-body">
            <p
              class="alert alert-danger text-center"
              v-if="hitSizeCap"
            >
              This email's attachments total over {{ attachmentSizeCapLbl }},
              which prevents the email from being sent to users.
            </p>
            <div
              v-if="!hitSizeCap"
            >
              <p
                v-if="sent"
                class="alert alert-success text-center"
              >
                This {{ title }} has been queued to be resent.
              </p>
              <flash
                ref="flash"
              ></flash>
              <div
                class="form-group"
              >
                <label
                  for="emails"
                >
                  Separate email addresses by commas:
                </label>
                <textarea
                  name="emails"
                  id="emails"
                  class="form-control"
                ></textarea>
              </div>
              <div class="form-check">
                <label
                  for="unrestricted"
                  class="form-check-label"
                >
                  <input
                    type="checkbox"
                    name="unrestricted"
                    id="unrestricted"
                    class="form-check-input"
                  />
                  <span
                    v-if="isNewsletter"
                  >
                    Allow sending to non-subscribers?
                  </span>
                  <span
                    v-else
                  >
                    Allow sending to
                    <span
                      v-if="isNewsletter"
                    >non-subscribers</span><span
                      v-else
                    >new users</span>?
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="resendEmails"
              v-if="!hitSizeCap"
            >
              Send
              <spinner size="small" v-if="loading"></spinner>
            </button>
            <button
              type="button"
              id="send-email-modal-close"
              class="btn btn-secondary"
              data-dismiss="modal"
            >Close</button>
          </div>
      </div>
    </div>
  </div>

  <button
    type="submit"
    class="btn btn-primary form-control"
    data-toggle="modal"
    data-target="#send-to-emails-modal"
  >
    Manually Send to Email Addresses
  </button>
</div>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import Flash from '@/components/Flash'

import FlashStore from '@/stores/FlashStore'

import EmailMixin from '@/mixins/EmailMixin'

import { mapState } from 'vuex'

export default {
  data () {
    return {
      createSubs: undefined,
      emails: undefined,
      loading: false,
      sent: undefined,
      verified: undefined
    }
  },

  components: {
    flash: Flash,
    spinner: Spinner
  },

  computed: mapState({
    base: state => state.base,
    email: state => state.EmailModule.email
  }),

  props: {
    hitSizeCap: {
      type: Boolean,
      default: false
    }
  },

  mixins: [ EmailMixin ],

  methods: {
    resendEmails (ev) {
      const emailsEle = document.getElementById('emails')
      const emails = emailsEle.value
      const unrestricted = document.getElementById('unrestricted').checked

      if (!emails) {
        FlashStore.errors(['No emails assigned'])
        return
      }

      this.sent = false
      ev.target.disabled = true
      FlashStore.clear()

      this.$store.dispatch(
        'EmailModule/resendEmails', {
          emails: emails,
          unrestricted: unrestricted,
          type: this.email.type
        }
      ).then(() => {
        this.sent = true

        FlashStore.result('This email has been sent!')
      }).catch((ev) => {
        this.$root.processErrors(ev)
      }).finally(() => {
        this.$root.forceCloseModal()
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/EmailSendToEmails.vue